module.exports = __webpack_public_path__ + "static/media/sample_lmtransporters.b518b2f8.csv";